import Pusher from 'pusher-js';

export default defineNuxtPlugin((nuxtApp) => {

  const config = useRuntimeConfig();

  // Initialize Pusher with your app key and options
  const pusher = new Pusher(config.public.pusherKey as string, {
    cluster: config.public.pusherCluster as string,
    wsHost: config.public.pusherHost as string,
    wsPort: parseInt(config.public.pusherPort),
    wssPort: parseInt(config.public.pusherPort),
    forceTLS: (config.public.pusherScheme as string) === "https",
    enabledTransports: ["ws", "wss"],
  })

  return {
    provide: {
      pusher
    }
  }
})